import { useLazyQuery } from "@apollo/client";
import { getValue } from "@clockwise/client-commons/src/util/errorable.util";
import { debounce } from "lodash";
import { useCallback, useEffect, useState } from "react";
import { InviteSearchPerson } from "../InviteSearch";
import { convertSearchPersonToInviteSearchPerson } from "../utils/convertSearchPersonToInviteSearchPerson";
import { InviteSearchDocument } from "./__generated__/InviteSearch.generated";

export const useInviteSearch = (suggestionIds: string[]) => {
  const [results, setResults] = useState<InviteSearchPerson[]>([]);
  const suggestionsIdSet = new Set(suggestionIds);

  const [search, { data, loading }] = useLazyQuery(InviteSearchDocument);

  useEffect(() => {
    const orgs = data?.viewer?.user?.orgs.edges;
    const searchPersons = !!orgs
      ? getValue(orgs[0]?.node?.orgPersonListPaginatedErrorable)?.searchPersons
      : [];

    const resultsAsInviteSearchPerson = searchPersons
      ? searchPersons.map((person) => {
          const isSuggested = suggestionsIdSet.has(person.person.primaryCalendarId);
          return convertSearchPersonToInviteSearchPerson(person, isSuggested);
        })
      : [];

    setResults(resultsAsInviteSearchPerson);
  }, [data, loading]);

  const debouncedSearch = useCallback(debounce(search, 500), []);

  return { loading, results, search: debouncedSearch };
};
